(() => {
  const root = document.documentElement;
  const key = 'inthatpack-reading-v8';
  const sizes = new Set(['default', 'large', 'larger']);
  if (window.ITPReadingV14) return;
  window.ITPReadingV14 = true;
  let dialog;
  let release = () => {};
  const mount = () => {
    release();
    dialog = document.querySelector('[data-reading-dialog]');
    if (!dialog) return;
    const controller = new AbortController();
    const listen = (target, type, callback) => target?.addEventListener(type, callback, {signal:controller.signal});
    release = () => { controller.abort(); if (dialog?.open) dialog.close(); document.body.classList.remove('itp-reading-open'); };
    dialog.dataset.ready = 'true';
  let opener;
  let preferences = { size: 'default', calm: false };
  try {
    const saved = JSON.parse(window.localStorage.getItem(key) || '{}');
    preferences = { size: sizes.has(saved.size) ? saved.size : 'default', calm: saved.calm === true };
  } catch {}

  const status = dialog.querySelector('[data-reading-status]');
  const apply = (announce = '') => {
    root.dataset.readingSize = preferences.size;
    root.dataset.readingCalm = preferences.calm ? 'on' : 'off';
    dialog.querySelectorAll('[name="itp-reading-size"]').forEach(input => { input.checked = input.value === preferences.size; });
    dialog.querySelector('[name="itp-reading-calm"]').checked = preferences.calm;
    if (announce && status) status.textContent = status.dataset[announce] || '';
  };
  const save = announce => {
    let stored = false;
    try { window.localStorage.setItem(key, JSON.stringify(preferences)); stored = true; } catch {}
    apply(stored ? announce : 'temporary');
  };
  const close = () => { if (dialog.open) dialog.close(); };

  document.querySelectorAll('[data-reading-open]').forEach(button => {
    if (typeof dialog.showModal !== 'function') return;
    button.hidden = false;
    listen(button, 'click', () => {
      if (dialog.open) return;
      opener = button;
      if (status) status.textContent = '';
      dialog.showModal();
      document.body.classList.add('itp-reading-open');
      dialog.querySelector('h2').focus({ preventScroll: true });
    });
  });
  dialog.querySelectorAll('[data-reading-close]').forEach(button => listen(button, 'click', close));
  listen(dialog, 'close', () => {
    document.body.classList.remove('itp-reading-open');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  listen(dialog, 'click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  listen(dialog, 'change', event => {
    const input = event.target;
    if (input.name === 'itp-reading-size' && sizes.has(input.value)) preferences.size = input.value;
    else if (input.name === 'itp-reading-calm') preferences.calm = input.checked;
    else return;
    save('saved');
  });
  listen(dialog.querySelector('[data-reading-reset]'), 'click', () => {
    preferences = { size: 'default', calm: false };
    save('reset');
  });
  listen(window, 'storage', event => {
    if (event.key !== key) return;
    try {
      const saved = JSON.parse(event.newValue || '{}');
      preferences = { size: sizes.has(saved.size) ? saved.size : 'default', calm: saved.calm === true };
      apply();
    } catch {}
  });
  apply();
  };
  mount();
  document.addEventListener('shopify:section:load', event => { if (event.target.querySelector('[data-reading-dialog]')) mount(); });
  document.addEventListener('shopify:section:unload', event => { if (dialog && event.target.contains(dialog)) release(); });
})();
